import React from "react";
import Swiper from "swiper";
import { Navigation, Thumbs } from "swiper/modules";
import PhotoSwipeLightbox from "photoswipe/dist/photoswipe-lightbox.esm.js";
import type PhotoSwipeLightboxInstance from "photoswipe/lightbox";
//not load dynamic, load at first, otherwise click image will open another tab
import PhotoSwipe from "photoswipe/dist/photoswipe.esm.js";
import { leftArrowSVGString, rightArrowSvgString } from "./svg";
import $ from "jquery";
import { useIsMobile } from "../../components/hooks";

const PDPImageSwiper = () => {
  const isMobile = useIsMobile();

  React.useEffect(() => {
    let imageThumbs;
    if (!isMobile) {
      imageThumbs = new Swiper(".pdp-thumbs", {
        slidesPerView: "auto",
        spaceBetween: 10,
        direction: "vertical",
        autoHeight: true,
      });
    }

    new Swiper(".pdp-images", {
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      direction: "horizontal",
      modules: [Navigation, Thumbs],
      watchOverflow: true,
      simulateTouch: false,
      thumbs: {
        swiper: imageThumbs,
      },
      breakpoints: {
        767: {
          direction: "vertical",
          autoHeight: true,
        },
      },
    });

    const items = [
      ...document.querySelectorAll<HTMLAnchorElement>("#image-gallery a"),
    ];
    const lightbox: PhotoSwipeLightboxInstance = new PhotoSwipeLightbox({
      dataSource: items.map((a) => ({
        id: a.href,
        src: a.href,
        width: a.dataset.pswpWidth ? parseInt(a.dataset.pswpWidth, 10) : 0,
        height: a.dataset.pswpHeight ? parseInt(a.dataset.pswpHeight, 10) : 0,
      })),

      pswpModule: PhotoSwipe,
      initialZoomLevel: "fill",
      bgOpacity: 0.85,
      arrowPrevSVG: leftArrowSVGString,
      arrowNextSVG: rightArrowSvgString,
      wheelToZoom: true,
    });

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      item.addEventListener("click", (e) => {
        e.preventDefault();
        lightbox.loadAndOpen(i);
      });
    }

    if (!isMobile) {
      const imgs = $<HTMLImageElement>("#image-gallery img").clone();

      function getThumbnails() {
        return document.querySelectorAll<HTMLImageElement>(
          "div.photoSwipe_innerthumbs img"
        );
      }

      lightbox.on("beforeOpen", () => {
        $("body").append('<div class="photoSwipe_innerthumbs"></div>');
        imgs.appendTo("div.photoSwipe_innerthumbs");

        const thumbnails = getThumbnails();
        const maxHeight = `calc(100vh / ${thumbnails.length + 2})`;
        const currIndex = lightbox.pswp?.currIndex || 0;

        for (let i = 0; i < thumbnails.length; i++) {
          const img = thumbnails[i];

          img.style.maxHeight = maxHeight;
          img.addEventListener("click", () => lightbox.pswp?.goTo(i));

          if (i === currIndex) {
            img.classList.add("active");
          }
        }
      });

      lightbox.on("change", function () {
        const thumbnails = getThumbnails();
        const currIndex = lightbox.pswp?.currIndex || 0;

        for (let i = 0; i < thumbnails.length; i++) {
          if (i === currIndex) {
            thumbnails[i].classList.add("active");
          } else {
            thumbnails[i].classList.remove("active");
          }
        }
      });

      lightbox.on("close", () => $(".photoSwipe_innerthumbs").remove());
    }

    lightbox.addFilter("useContentPlaceholder", () => false);
    lightbox.init();

    return () => {
      lightbox.destroy();
    };
  }, [isMobile]);

  return null;
};

export default PDPImageSwiper;
